import { gql } from '@apollo/client';

export const AVAILABLE_WEBSITES = gql`
  query getAvailableWebsites($country: Country!, $vehicleDomain: VehicleDomain!) {
    getAvailableWebsites(country: $country, vehicleDomain: $vehicleDomain)
  }
`;
